import React, { useState, useContext, useEffect } from "react";
import Application from "../../../StateContext/Application";
import { apiurl } from '../../../../../path'
const Authorization = () => {
    const statecalls = useContext(Application);
    const { AuthorizationFiles, Authorizationverify, CreateToken, Authorizationreject, ReUploadDocument,ReUploadCancelDocument } = statecalls;
    const [AuthData, SetAuthData] = useState([])
    const [TenderID, SetTenderId] = useState([])
    const [hide, sethide] = useState(true)
    const [Etoken, SetEtoken] = useState(false)
    const [GenerateToken, SetGenerateToken] = useState(true)
    const [GenerateRejectToken, SetGenerateRejectToken] = useState(true)
    const [Remark, SetRemark] = useState(""); // New state for remark
    const [Document, SetDocument] = useState(null); // File upload state
    const [CancelDocument, SetCancelDocument] = useState(null); // File upload state
    useEffect(() => {
        Getdata()

        return () => {
        }
    }, [])


    async function Getdata() {
        let data = await AuthorizationFiles()
        console.log(data);
        SetAuthData(data)
    }
    async function Approve() {
        let data = await Authorizationverify(TenderID, Etoken)
        alert(data)
        window.location.reload()
        Getdata()
    }

    async function Reject() {
        if (!Remark.trim()) {
            alert("Please provide a remark before rejecting.");
            return;
        }
        let data = await Authorizationreject(TenderID, Etoken, Remark)
        alert(data)
        window.location.reload()
        SetRemark(""); // Reset remark after submission
        Getdata()
    }

    async function GenerateTokenFor(e) {
        e.preventDefault();
        let data = await CreateToken('Refund Approval');
        document.getElementById('tokencopys').innerText = data
        SetEtoken(data)
        sethide(false)
    }

    async function HandleFileUpload(auction) {
        if (!Document) {
            alert("Please select a document to upload.");
            return;
        }

        const formData = new FormData();
        formData.append("TenderID", auction.Tender_ID);
        formData.append("WinnerDocument", Document);

        try {
            const response = await ReUploadDocument(formData);
            alert(response.message || "Document uploaded successfully.");
            Getdata(); // Refresh data after upload
        } catch (error) {
            alert("Failed to upload document. Please try again.");
        } finally {
            SetDocument(null); // Reset document input
        }
    }

    async function HandleCancelFileUpload(auction) {
        if (!CancelDocument) {
            alert("Please select a document to upload.");
            return;
        }

        const formData = new FormData();
        formData.append("TenderID", auction.Tender_ID);
        formData.append("Cancel_Docs", CancelDocument);

        try {
            const response = await ReUploadCancelDocument(formData);
            alert(response.message || "Document uploaded successfully.");
            Getdata(); // Refresh data after upload
        } catch (error) {
            alert("Failed to upload document. Please try again.");
        } finally {
            SetDocument(null); // Reset document input
        }
    }


    return (
        <div>
            <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%', justifyContent: 'center' }}>
                {AuthData && AuthData.map((auction, key) => (
                    <div key={key} className="card" style={{ width: '100%', margin: '1rem', }}>
                        <div className="card-body" style={{ display: "grid" }}>
                            <h5 style={{ textAlign: "center" }} className="card-title">{auction.Tender_Name}{auction.TenderWinnerStatus !== "Cancel" ? '' : <h5 style={{ color: "red" }}>(Cancelled)</h5>}</h5>
                            <hr></hr>
                            <div style={{ display: "flex", justifyContent: "space-evenly" }}>
                                <div style={{ display: "flex" }}>
                                    <div>
                                        <h6><b>Contact Information</b></h6><hr></hr>
                                        <h6><b>Department Name</b></h6><hr></hr>
                                        <h6><b>Ernest Money Deposit</b></h6><hr></hr>
                                        <h6><b>GST</b></h6><hr></hr>
                                    </div>
                                    <div>
                                        <h6>: {auction.Contact_Information}</h6><hr></hr>
                                        <h6>: {auction.Department_Name}</h6><hr></hr>
                                        <h6>: {auction.ErnestMoneyDeposit}</h6><hr></hr>
                                        <h6>: {auction.GST}</h6><hr></hr>
                                    </div>
                                </div>
                                <div style={{ display: "flex" }}>
                                    <div>
                                        <h6><b>PO Number</b></h6><hr></hr>
                                        <h6><b>Tender Fee</b></h6><hr></hr>
                                        <h6><b>Tender Winner Name</b></h6><hr></hr>
                                        <h6><b>Tender Refund Status</b></h6><hr></hr>
                                    </div>
                                    <div>
                                        <h6>: {auction.PO_Number}</h6><hr></hr>
                                        <h6>: {auction.TenderFee}</h6><hr></hr>
                                        <h6>: {auction.TenderWinnerName}</h6><hr></hr>
                                        <h6>: {auction.TenderWinnerStatus}</h6><hr></hr>
                                    </div>
                                </div>
                            </div>
                            <div style={{ display: "flex", justifyContent: "center" }}>
                                <div>
                                    <h6><b>Total Refundable Amount</b></h6><hr></hr>
                                </div>
                                <div>
                                    <h6>: <b>{auction.total_emd||0}</b></h6><hr></hr>
                                </div>
                            </div>
                            <div style={{ display: "flex", justifyContent: "center" }}>
                                {
                                    auction.TenderWinnerStatus !== "Cancel" ? <p><a href={`${apiurl}/WinnerDocuments/${auction.WinnerDocument}`} target='_blank'>View Winner Docs</a></p> : <p><a href={`${apiurl}/AuctionDetailsget/${auction.WinnerDocument}`} target='_blank'>View Cancel Docs</a></p>
                                }
                            </div>
                            <div style={{ display: "flex", justifyContent: "space-evenly" }}>
                                <button href="#" className="btn btn-success mx-2 my-3" style={{ backgroundColor: "transparent", color: "green", width: "100%" }} onClick={(e) => { SetGenerateToken(false); SetTenderId(auction.Tender_ID) }}>Approve</button>
                            </div>
                            <div style={{ display: "flex", justifyContent: "space-evenly" }}>
                                <button href="#" className="btn btn-danger mx-2" style={{ backgroundColor: "transparent", color: "red", width: "100%" }} onClick={(e) => { SetGenerateRejectToken(false); SetTenderId(auction.Tender_ID) }}>Reject</button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <div class="card" style={{ width: '100%', height: '100%', position: "absolute", left: "0", bottom: "0" }} hidden={GenerateToken}>
                <div class="card-body">
                    <h6>Send Message</h6>
                    <div class="card form-control" style={{ width: "100%" }}>
                        <div class="card-body">
                            <h5 class="card-title">Generate Token</h5>
                            <textarea class="form-control" id='tokencopys' value={Etoken}></textarea>
                            <button hidden={Etoken} className='btn btn-success mx-2' style={{ backgroundColor: "rgb(10, 200, 150)", border: "none", borderRadius: "10px" }} onClick={GenerateTokenFor}>Generate Token</button>

                        </div>
                        {AuthData.find(a => a.Tender_ID === TenderID)?.DocumentApproval === "false" && AuthData.find(a => a.Tender_ID === TenderID)?.TenderWinnerName !== "Cancel" && (
                            <div>
                                <label htmlFor={`upload-${TenderID}`}>Upload Document:</label>
                                <input
                                    id={`upload-${TenderID}`}
                                    type="file"
                                    className="form-control"
                                    onChange={(e) => SetDocument(e.target.files[0])}
                                />
                                <button
                                    className="btn btn-primary my-2"
                                    onClick={() => HandleFileUpload(AuthData.find(a => a.Tender_ID === TenderID))}
                                >
                                    Upload Document
                                </button>
                            </div>
                        )}
                        {AuthData.find(a => a.Tender_ID === TenderID)?.DocumentApproval === "false" && AuthData.find(a => a.Tender_ID === TenderID)?.TenderWinnerName === "Cancel" && (
                            <div>
                                <label htmlFor={`upload-${TenderID}`}>Upload Cancel Document:</label>
                                <input
                                    id={`upload-${TenderID}`}
                                    type="file"
                                    className="form-control"
                                    onChange={(e) => SetCancelDocument(e.target.files[0])}
                                />
                                <button
                                    className="btn btn-primary my-2"
                                    onClick={() => HandleCancelFileUpload(AuthData.find(a => a.Tender_ID === TenderID))}
                                >
                                    Upload Document
                                </button>
                            </div>
                        )}
                    </div>

                    <button className='btn btn-success mx-2 my-2' onClick={Approve} hidden={hide} >Approve</button>
                    <button className='btn btn-danger' onClick={(x) => SetGenerateToken(true)}>close</button>
                </div>
            </div>

            <div class="card" style={{ width: '100%', height: '100%', position: "absolute", left: "0", bottom: "0" }} hidden={GenerateRejectToken}>
                <div class="card-body">
                    <h6>Send Message</h6>
                    <div class="card form-control" style={{ width: "100%" }}>
                        <div class="card-body">
                            <h5 class="card-title">Generate Token</h5>
                            <textarea class="form-control" id='tokencopys' value={Etoken}></textarea>
                            <button hidden={Etoken} className='btn btn-success mx-2' style={{ backgroundColor: "rgb(10, 200, 150)", border: "none", borderRadius: "10px" }} onClick={GenerateTokenFor}>Generate Token</button>
                        </div>
                    </div>
                    <div className="form-group my-3">
                        <label htmlFor="remark">Remark (Required for Rejection):</label>
                        <textarea
                            id="remark"
                            className="form-control"
                            placeholder="Enter your remark here"
                            value={Remark}
                            onChange={(e) => SetRemark(e.target.value)}
                        />
                    </div>
                    <button className='btn btn-success mx-2' onClick={Reject} hidden={hide} >Reject</button>
                    <button className='btn btn-danger' onClick={(x) => SetGenerateRejectToken(true)}>close</button>
                </div>
            </div>
        </div>
    )
}

export default Authorization